var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-form',{staticStyle:{"margin-top":"8px"},attrs:{"form":_vm.form}},[_c('online-form-item',{attrs:{"properties":_vm.properties}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }